
<template>
    <div class="brand">
         <img src="../../assets/imgs/brand/brand-1.jpg" style="width: 100%;"/>
         <div class="section-content posBox" >
             <div class=" banner-box flexAlign">
               <div class="flexAlign" style="width: 510px;">
                 <div><img src="../../assets/imgs/brand/qty.png" style="width: 138px;margin-right: 30px;" /></div>
                   <div class="title" style="  width: 380px;">
                      <div>A brand with profound  cultural background</div>
                      <p class="black">有底蕴的品牌</p>
                  </div>
              </div>
              <div class="info" >
                 <p>始于1958，专注教育<span>65</span>年;</p><p>
                  源于东方,深受儒家文化影响; </p><p>
                  遍布全球<span>19</span>个国家和地区, 拥有<span>600</span>多家教学中心; </p><p>
                  遍布中国<span>40</span>多个大中城市, 开设<span>110</span>多家教学中心;</p><p>
                  真心、真情、真教育。</p>
              </div>
             </div>
         </div>
         <div class="section-content">
             <div class="brand-speed">
                 <div class="title">
                     <div>Development process</div>
                     <p class="black">发展历程</p>
                 </div>
                 <p>65年匠心教育，七田真先进的教学理念和教育方法远播到世界各地，</p>
                 <p>为万千爱心家庭提供科学、严谨、专业的服务。
                 <p>10年中国深耕，七田真先后获得了新浪、腾讯、凤凰网多项教育大奖，</p>
                 <p>收获了无数爱心家庭的口碑好评。</p>
             </div>
             <div class="news">
                 <div class="prev"><img src="../../assets/imgs/brand/prev.jpg" style="width:70px;" @click="prevFn()" /></div>
                 <div class="news-content ">
                     <div class="title-news-box">
                         <div class="year-time">{{newsArr[i].Name}}</div>
                         <div class="news-title" v-for="(item,index) in newsArr[i].Intros" :key="index">{{item}}</div>

                     </div>
                     <div class="imgBox">
                         <img :src="newsArr[i].Img.url" />
                     </div>
                 </div>
                 <div class="next"><img src="../../assets/imgs/brand/next.jpg" @click="nextFn()" style="width:70px;"/></div>
             </div>
             <img src="../../assets/imgs/brand/brand-qtz.png" />
             <div class="numInfo">
                  <div class="flexAlign">
                      <div><span>65</span>年历史</div>
                      <div><span>19</span>个国家及地区</div>
                      <div><span>720</span>篇教案</div>
                  </div>
                 <div class="flexAlign" >
                     <div><span>200</span>余本教育著作</div>
                     <div><span>2000</span>多种特色教具</div>
                 </div>
             </div>
             <div class="ceo">
                 <div style="width: 580px;">
                     <img src="../../assets/imgs/brand/ceo.png" style="width: 100%;">
                 </div>
                 <div class="infoBox">
                     <div class="title" style="margin-top: 75px;">
                         <div>Shichida  China</div>
                         <p class="black" style="font-family: Heavy;">七田真中国·创始人</p>
                     </div>
                     <div style="font-size: 50px;font-weight: 600;color:#303030;margin-top: 10px;">马思延</div>
                     <span style="display: inline-block;width:40px;height:0px;border-bottom: 5px solid #fdb813;margin-top: 20px;"></span>
                     <div style="font-family: Medium;font-size: 24px;color:#303030;margin: 10px 0px;">思可国际教育集团 董事长</div>
                    <p>七田真国际教育 CEO</p>
                    <p>小王子语言中心 创始人</p>
                    <p>思可爱心基金 创始人</p>
                    <p>科学育儿 探索者</p>
                    <p>长春大学、 黑龙江外国语学院、 黑龙江东方学院、
                        哈尔滨华德学院、 广东第二师范学院 教授</p>
                    <p style="margin-top: 40px">北京大学物理系学士， 清华大学近代物理系研究生， 加拿大麦
                        吉尔MCGILL大学MBA， 日本一桥大学在读博士。
                        1987年参与方正集团创立， 1993年-2009年期间就职于全球最
                        大的财经资讯公司-彭博资讯， 任亚太区运营总裁。 在取得事业
                        成功的同时， 深刻认识到人才的培养始于科学的早期教育。
                        自2008年起关注、 研究中国早期教育， 2009年将在日本拥有65
                        年历史的世界知名早期教育品牌-七田真正式引入中国。
                        十余年来， 深耕教育行业， 屡获佳绩。 荣获2018-2019华人教
                        育家大会“改革开放40年成就人物” ， 2019-2020华人教育家
                        大会“共和国70年教育荣耀人物“， 腾讯教育年度盛典2019年
                        度教育行业领军人物。</p>
                    <!-- <p style="margin-top:20px"> 自2008年起关注、研究中国早期教育，2009年将最适合东方文化的世界知名早期教育品牌——七田真正式引入中国。</p> -->
                </div>
             </div>
             <div class="map">
                 <div class="banner">
                     <div class="content">2009年进入中国, 40多个大中型城市, 110多家教学中心</div>
                 </div>
                 <img src="https://smart-resource.sikegroup.com/pc-city-5.jpg" style="margin: 20px 0px;width: 100%;">
                 <!--<span style="position:absolute;bottom:50px;left:40px;font-size: 16px;">*数据截止到2022年9月</span>-->
             </div>
         </div>



    </div>
</template>
<script>
  export default {
      data(){
          return {
             newsArr:[],
             i: 0,
          }
      },
      created(){
         this.newFn();
      },
      methods:{
        newFn(){
            this.$http.get('https://q.qitianzhen.cn/api/brand_adv').then((res)=>{
               this.newsArr = res.body.list;
            })
        },
        nextFn(){
           this.i++;
            if(this.i==this.newsArr.length){
             this.i=0;
            }

        },
        prevFn(){
            this.i--;
            if(this.i==-1){
               this.i=this.newsArr.length-1;
            }
        },
      }
  }

</script>
<style scoped lang="less">
  .brand {
      width: 100%;
      color: #5e5e5e;
      font-size: 20px;
      font-family: Light;
      position: relative;
      .banner-box{
          margin: 0px auto;
          border-radius: 6px;
          height: 310px;
          box-shadow: 0px 4px 6px #cecece;
          background: url('../../assets/imgs/brand/bg-1.png') no-repeat; background-position: 92% 10%;
      }
      .posBox{
          margin-top: -64px;
          position: relative;
          background-color: #ffffff;
          border-radius: 6px;
          .info{
              /*color:#686868;*/
              /*font-size: 20px;*/
              /*font-family: Light;*/
              width: 460px;
              p{
                  line-height: 34px;
                  span{
                      font-weight: 600;
                      color: #fbc200;
                  }
              }

          }
      }

      .title{
          color: #fdb813;
          font-size: 30px;
          font-weight: 600;
          div{
              line-height: 34px;
              margin-bottom: 10px
          }
      }
      .brand-speed{
          text-align: center;
          padding: 110px 0px 240px;
          background-color: #ffffff;
          background: url('../../assets/imgs/brand/speed-bg.png') no-repeat;
          background-size: 100% 54%;
          background-position: left  bottom;
          &>p:nth-child(2n){
              margin-top: 46px;
          }
      }
      .news {
          height: 620px;
          display: flex;
          margin-top: 100px;
           .next{
               width: 140px;
               height: 620px;
               display: flex;
               align-items: center;
               justify-content: flex-end;
               cursor: pointer;
           }
          .prev{
              width: 140px;
              height: 620px;
              display: flex;
              align-items: center;
              cursor: pointer;
          }
          .news-content {
              display: inline-block;
              width: 1000px;
              height: 560px;
              position: relative;
              background: url('../../assets/imgs/brand/news-bg.png') 100% 100% no-repeat;
              .title-news-box{
                  width: 300px;
                  height: 543px;
                  padding: 50px 0px;
                  background: url('../../assets/imgs/brand/time-bg.png') 100% 100% no-repeat;
                  background-position: 0% 10%;
                  .year-time{
                      font-family: Heavy;
                      font-size: 36px;
                      color: #ffffff;
                      margin-top: 6px;
                      text-indent: 50px;
                  }
                  .news-title{
                      width: 180px;
                      margin-left: 80px;
                      margin-top: 35px;
                  }

              }
              .imgBox{
                  width: 680px;
                  position: absolute;
                  top: 0px;
                  right: 0px;
                  img{
                      margin: 62px 50px;
                      border: 6px solid #fdc47f;
                      border-radius: 10px;
                      overflow: hidden;
                      width: 580px;
                      height: 400px;
                  }
              }
          }
      }
      .numInfo{
          width: 84%;
          margin: 10px auto;
          border: 1px solid #feb428;
          font-weight: normal;
          font-size: 30px;
          color: #5e5e5e;
          padding: 10px 0px;
          span{
              font-family: Heavy;
              font-size: 92px;
              color: #fdb831;
          }
      }
      .ceo{
          display: flex;
          margin-top: 40px;
          align-items: center;
          .infoBox{
                width: 680px;
                height: 840px;
                background: url('../../assets/imgs/brand/ceo-bg.png') 100% 100% no-repeat;
                background-size:  100% 100%;
                padding-left: 60px;
                &>p{
                    line-height: 30px;
                    width: 534px;
                    font-size: 16px;
                }
          }
      }
      .map{
          margin-top: 30px;
          position:relative;
          .banner{
              height: 150px;
              line-height: 150px;
              width: 100%;
              border-radius: 50px;
              background-color: #fdba21;
             .content{
                 display: inline-block;
                 width: calc(100% - 48px);
                 color: #ffffff;
                 font-size: 45px;
                 height: 100px;
                   line-height: 100px;
                   margin: 20px 20px;
                   border: 4px dashed #ffffff;
                   border-radius: 36px;
                   text-align: center;
                 font-weight: 600;
                 background-color: #fdb831;
                 box-shadow: 2px 8px 10px #e9ae3a;
              }
          }
      }
  }

</style>
